
import {GlobeAltIcon, LightningBoltIcon, ScaleIcon } from '@heroicons/react/outline'
import ResultPage from '../../assets/resultpagemockup.png'
import HomePage from '../../assets/homepagemockup.png'
import {Bounce} from 'react-reveal';
import {FireIcon, ShoppingBagIcon} from "@heroicons/react/solid";
const transferFeatures = [
    {
        id: 1,
        name: 'Trivia Kicks',
        description:
            'This is the basic mode which you can play any time. Select any category of your choice. There are 5 levels starting from Easy to Hard, 5 questions with every level. You can earn a total of 15 points by completing all 5 levels, completing the Hard level also earn you a golden ball!',
        icon: LightningBoltIcon,
    },
    {
        id: 2,
        name: 'Challenge',
        description:
            'Challenge another user or a leader (to test how you fare against a leader). Pay coins to play, with every challenge win you earn more coins',
        icon: GlobeAltIcon,
    },
    {
        id: 3,
        name: '1 vs 1',
        description:
            'You can play the quiz against real time users! Both the users get the same questions and who answers most the questions with the game. You can play for free or if you want to earn rewards you can play by paying coins. Winning user earns more coins',
        icon: ScaleIcon,
    },
]
const communicationFeatures = [
    {
        id: 1,
        name: 'Game',
        description:
            'Play the Trivia kicks mode, score maximum points. For every 10 points that gets converted to 1 coin. Coins also can be earned by playing 1 vs 1 or Challenge mode and beat the other player',
        icon: FireIcon,
    },
    {
        id: 2,
        name: 'Store',
        description:
            'The in-app store has several packages of coins that can be purchased and consumed in various game modes.',
        icon: ShoppingBagIcon,
    },
]

export default function Rules() {
    return (
        <div className="py-16 bg-white overflow-hidden lg:py-10 relative ">
            <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
                <svg
                    className="hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/7"
                    width={404}
                    height={784}
                    fill="none"
                    viewBox="0 0 404 784"
                    aria-hidden="true"
                >
                    <defs>
                        <pattern
                            id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
                            x={0}
                            y={0}
                            width={20}
                            height={20}
                            patternUnits="userSpaceOnUse"
                        >
                            <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                        </pattern>
                    </defs>
                    <rect width={404} height={784} fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)" />
                </svg>

                <div className="relative lg:top-10">
                    <h2 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                        Rules
                    </h2>
                    <p className="mt-4 max-w-3xl mx-auto text-center text-xl text-gray-500">
                        Learn how to play 5 Penalties
                    </p>
                </div>

                <div className="relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
                    <div className="relative">
                        <h3 className="text-2xl font-extrabold text-gray-900 tracking-tight sm:text-3xl">
                            So what the game is about
                        </h3>
                        <p className="mt-3 text-lg text-gray-500">
                            Through the points you can earn coins, collect more coins you can redeem that to real world rewards ! Yes, knowledge of your favourite sport and team can earn you gift vouchers , football merchandises , personalised gifts and many more exciting rewards
                            <br/>
                            <br/>
                            Every point you score helps you to climb positions on the leader board and show to the world about your achievement.
                            <br/>
                            <br/>
                            There are 3 games modes.
                        </p>

                        <dl className="mt-10 space-y-10">
                            {transferFeatures.map((item) => (
                                <div key={item.id} className="relative">
                                    <dt>
                                        <div className="absolute flex items-center justify-center h-12 w-12 rounded-md theme text-white">
                                            <item.icon className="h-6 w-6" aria-hidden="true" />
                                        </div>
                                        <p className="ml-16 text-lg leading-6 font-medium text-gray-900">{item.name}</p>
                                    </dt>
                                    <dd className="mt-2 ml-16 text-base text-gray-500">{item.description}</dd>
                                </div>
                            ))}
                        </dl>
                    </div>

                    <div className="mt-10 -mx-4 relative lg:mt-0" aria-hidden="true">
                        <svg
                            className="absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden"
                            width={784}
                            height={404}
                            fill="none"
                            viewBox="0 0 784 404"
                        >
                            <defs>
                                <pattern
                                    id="ca9667ae-9f92-4be7-abcb-9e3d727f2941"
                                    x={0}
                                    y={0}
                                    width={20}
                                    height={20}
                                    patternUnits="userSpaceOnUse"
                                >
                                    <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width={784} height={404} fill="url(#ca9667ae-9f92-4be7-abcb-9e3d727f2941)" />
                        </svg>
                        <Bounce right>
                            <img
                                className="relative mx-auto"
                                width={550}
                                src={ResultPage}
                                alt=""
                            />
                        </Bounce>
                    </div>
                </div>

                <svg
                    className="hidden lg:block absolute right-full transform translate-x-1/2 translate-y-12"
                    width={404}
                    height={784}
                    fill="none"
                    viewBox="0 0 404 784"
                    aria-hidden="true"
                >
                    <defs>
                        <pattern
                            id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                            x={0}
                            y={0}
                            width={20}
                            height={20}
                            patternUnits="userSpaceOnUse"
                        >
                            <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                        </pattern>
                    </defs>
                    <rect width={404} height={784} fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" />
                </svg>

                <div className="relative mt-12 sm:mt-16 lg:mt-24">
                    <div className="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
                        <div className="lg:col-start-2">
                            <h3 className="text-2xl font-extrabold text-gray-900 tracking-tight sm:text-3xl">How to earn/buy coins</h3>
                            <p className="mt-3 text-lg text-gray-500">
                                Coins are the only currency in  the game. You can earn coins through 2 ways.
                            </p>

                            <dl className="mt-10 space-y-10">
                                {communicationFeatures.map((item) => (
                                    <div key={item.id} className="relative">
                                        <dt>
                                            <div className="absolute flex items-center justify-center h-12 w-12 rounded-md theme text-white">
                                                <item.icon className="h-6 w-6" aria-hidden="true" />
                                            </div>
                                            <p className="ml-16 text-lg leading-6 font-medium text-gray-900">{item.name}</p>
                                        </dt>
                                        <dd className="mt-2 ml-16 text-base text-gray-500">{item.description}</dd>
                                    </div>
                                ))}
                            </dl>
                        </div>

                        <div className="mt-10 -mx-4 relative lg:mt-0 lg:col-start-1">
                            <svg
                                className="absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden"
                                width={784}
                                height={404}
                                fill="none"
                                viewBox="0 0 784 404"
                                aria-hidden="true"
                            >
                                <defs>
                                    <pattern
                                        id="e80155a9-dfde-425a-b5ea-1f6fadd20131"
                                        x={0}
                                        y={0}
                                        width={20}
                                        height={20}
                                        patternUnits="userSpaceOnUse"
                                    >
                                        <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                                    </pattern>
                                </defs>
                                <rect width={784} height={404} fill="url(#e80155a9-dfde-425a-b5ea-1f6fadd20131)" />
                            </svg>
                            <Bounce left>
                                <img
                                    className="relative mx-auto"
                                    width={550}
                                    src={HomePage}
                                    alt=""
                                />
                            </Bounce>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
